var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "panel" }, [
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-horizontal" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "checkbox checkbox-primary col-sm-9" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.stateOpportunities,
                    expression: "stateOpportunities",
                  },
                ],
                attrs: {
                  type: "checkbox",
                  name: "opportunities[]",
                  id: `checkbox-opportunity-${_vm.opportunity.id}`,
                },
                domProps: {
                  value: { id: _vm.opportunity.id },
                  checked: Array.isArray(_vm.stateOpportunities)
                    ? _vm._i(_vm.stateOpportunities, {
                        id: _vm.opportunity.id,
                      }) > -1
                    : _vm.stateOpportunities,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.stateOpportunities,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = { id: _vm.opportunity.id },
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.stateOpportunities = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.stateOpportunities = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.stateOpportunities = $$c
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: { for: `checkbox-opportunity-${_vm.opportunity.id}` },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.opportunity.name) +
                      "\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            this.opportunitiesWithBudget.includes(
              _vm.opportunity.name.toLowerCase()
            )
              ? _c("div", { staticClass: "col-sm-3" }, [
                  _c(
                    "div",
                    {
                      class: _vm.$hasErrorClass(
                        _vm.$v.stateOpportunityBudget,
                        "form-group"
                      ),
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.stateOpportunityBudget.$model,
                            expression: "$v.stateOpportunityBudget.$model",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", placeholder: "Budget" },
                        domProps: {
                          value: _vm.$v.stateOpportunityBudget.$model,
                        },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.$v.stateOpportunityBudget,
                                "$model",
                                $event.target.value
                              )
                            },
                            function ($event) {
                              return _vm.setBudget({ id: _vm.opportunity.id })
                            },
                          ],
                        },
                      }),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          label: "Budget",
                          field: _vm.$v.stateOpportunityBudget,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.opportunity.children && _vm.opportunity.children.length > 0
      ? _c(
          "ul",
          _vm._l(_vm.opportunity.children, function (childOpportunity) {
            return _c(
              "profile-talent-availability-child-opportunity-item",
              {
                key: childOpportunity.id,
                attrs: {
                  childOpportunity: childOpportunity,
                  opportunity: _vm.opportunity,
                  budgets: _vm.budgets,
                  opportunitiesWithBudget: _vm.opportunitiesWithBudget,
                },
                on: { input: _vm.setBudget },
              },
              [
                childOpportunity.children &&
                childOpportunity.children.length > 0
                  ? _c(
                      "ul",
                      { staticStyle: { "list-style": "none" } },
                      _vm._l(
                        childOpportunity.children,
                        function (grandchildOpportunity) {
                          return _c(
                            "profile-talent-availability-grand-child-opportunity-item",
                            {
                              key: grandchildOpportunity.id,
                              attrs: {
                                grandchildOpportunity: grandchildOpportunity,
                                opportunity: _vm.opportunity,
                                budgets: _vm.budgets,
                              },
                              on: { input: _vm.setBudget },
                            }
                          )
                        }
                      ),
                      1
                    )
                  : _vm._e(),
              ]
            )
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }